/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PatientPrescriptionItem } from "./PatientPrescriptionItem";

export interface PrescriptionFeedItem {
  type?: "prescription";
  id: string;
  authored_at?: string | null;
  prescription: PatientPrescriptionItem;
}
